import { PayloadAction } from '@reduxjs/toolkit';

import { SidebarState } from 'editor/src/store/editorModules/sidebar/types';

const setLastGroupItemsReducer = (state: SidebarState, action: PayloadAction<SidebarState['lastGroupItems']>) => {
  state.lastGroupItems = action.payload;
};

export default setLastGroupItemsReducer;
